import React, { useState, useEffect } from "react";
import {
  Menu,
  X,
  Brain,
  ScanSearch,
  LayoutDashboard,
  History,
  FileText,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Activity,
  Search,
  LineChart,
  Settings,
  PieChart,
  HelpCircle,SaudiRiyal
} from "lucide-react";
import { cn } from "../../lib/utils";

const menuItems = [
  {
    icon: <LayoutDashboard className="h-5 w-5" />,
    collapsedIcon: <LayoutDashboard className="h-5 w-5" />,
    title: "Overview",
    path: "dashboard",
    tooltip: "Main Dashboard"
  },
  {
    icon: <History className="h-5 w-5" />,
    collapsedIcon: <History className="h-5 w-5" />,
    title: "Defect Library",
    path: "historie",
    tooltip: "View Library"
  },

  {
    icon: <FileText className="h-5 w-5" />,
    collapsedIcon: <FileText className="h-5 w-5" />,
    title: "Reports",
    path: "reports",
    tooltip: "View Reports"
  },

];

const Layout = ({ children, activePage, onPageChange, onLogout, user }) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isDesktopSidebarOpen, setIsDesktopSidebarOpen] = useState(true);
  const [showTooltip, setShowTooltip] = useState(null);

  useEffect(() => {
    return () => {
      setIsMobileSidebarOpen(false);
    };
  }, []);

  const handleMenuClick = (path) => {
    onPageChange(path);
    setIsMobileSidebarOpen(false);
  };

  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
      setIsMobileSidebarOpen(false);
    }
  };

  const toggleDesktopSidebar = () => {
    setIsDesktopSidebarOpen(!isDesktopSidebarOpen);
  };

  const CollapsedMenuItem = ({ item, isActive }) => (
    <div className="relative group">
      <button
        onClick={() => handleMenuClick(item.path)}
        className={cn(
          "w-full p-3 rounded-lg mb-1",
          "transition-all duration-200",
          isActive
            ? "bg-gradient-to-r from-blue-500/10 to-cyan-500/10 text-cyan-300"
            : "text-gray-400 hover:bg-gray-800 hover:text-white",
          item.title === "Ask Shaheen AI" && "bg-gradient-to-r from-blue-600 to-cyan-600 text-white hover:text-sky-200"
        )}
        onMouseEnter={() => setShowTooltip(item.path)}
        onMouseLeave={() => setShowTooltip(null)}
      >
        {item.collapsedIcon}
      </button>
      {showTooltip === item.path && (
        <div className="absolute left-16 top-2 z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded shadow-lg whitespace-nowrap">
          {item.tooltip}
        </div>
      )}
    </div>
  );

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      <nav className="flex-1 px-3 py-4">
        {isDesktopSidebarOpen ? (
          menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleMenuClick(item.path)}
              className={cn(
                "w-full flex items-center justify-center px-3 py-2 rounded-lg mb-1 text-sm",
                "transition-all duration-200 group",
                activePage === item.path
                  ? "bg-gradient-to-r from-blue-500/10 to-cyan-500/10 text-cyan-300"
                  : "text-gray-400 hover:bg-gray-800 hover:text-white",
                item.title === "Ask Shaheen AI" && "bg-gradient-to-r from-blue-600 to-cyan-600 text-white hover:text-sky-200"
              )}
            >
              <span className="flex items-center w-full">
                <span className="w-8 flex justify-center">{item.icon}</span>
                <span className="transition-all duration-200 ml-3">{item.title}</span>
              </span>
            </button>
          ))
        ) : (
          <div className="space-y-2">
            {menuItems.map((item) => (
              <CollapsedMenuItem
                key={item.path}
                item={item}
                isActive={activePage === item.path}
              />
            ))}
          </div>
        )}
      </nav>

      <div className={cn(
        "px-3 py-4 border-t border-gray-800",
        !isDesktopSidebarOpen && "text-center"
      )}>
        {isDesktopSidebarOpen ? (
          <>
            {/* <button
              onClick={() => handleMenuClick("settings")}
              className={cn(
                "w-full flex items-center px-3 py-2 rounded-lg mb-4 text-sm",
                "transition-colors duration-200",
                activePage === "settings"
                  ? "bg-gradient-to-r from-blue-500/10 to-cyan-500/10 text-cyan-300"
                  : "text-gray-400 hover:bg-gray-800 hover:text-white"
              )}
            >
              <span className="flex items-center w-full">
                <span className="w-8 flex justify-center"><Settings className="h-5 w-5" /></span>
                <span className="ml-3">Settings</span>
              </span>
            </button> */}
            <div className="text-center mb-4">
              <p className="text-xs text-gray-500">Licence ID: {user.username}</p>
            </div>
            <button
              onClick={handleLogoutClick}
              className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200"
            >
              <LogOut className="h-4 w-4" />
              <span>Sign out</span>
            </button>
          </>
        ) : (
          <>
            <div className="relative group mb-4">
              <button
                onClick={() => handleMenuClick("settings")}
                className="w-full p-3 rounded-lg text-gray-400 hover:bg-gray-800 hover:text-white transition-colors duration-200"
                onMouseEnter={() => setShowTooltip("settings")}
                onMouseLeave={() => setShowTooltip(null)}
              >
                <Settings className="h-5 w-5 mx-auto" />
              </button>
              {showTooltip === "settings" && (
                <div className="absolute left-16 top-2 z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded shadow-lg">
                  Settings
                </div>
              )}
            </div>
            <div className="relative group">
              <button
                onClick={handleLogoutClick}
                className="w-full p-2 rounded-lg text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200"
                onMouseEnter={() => setShowTooltip("logout")}
                onMouseLeave={() => setShowTooltip(null)}
              >
                <LogOut className="h-5 w-5 mx-auto" />
              </button>
              {showTooltip === "logout" && (
                <div className="absolute left-16 top-2 z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded shadow-lg">
                  Sign out
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );

  return (
    <div className="h-screen flex flex-col md:flex-row bg-[#0F1216] overflow-hidden">
      {/* Desktop Sidebar */}
      <div 
        className={cn(
          "hidden md:flex flex-col bg-[#171B21] border-r border-gray-800 transition-all duration-300 ease-in-out fixed h-full z-30",
          isDesktopSidebarOpen ? "w-64" : "w-16"
        )}
      >
        <div className={cn(
          "h-16 flex items-center border-b border-gray-800",
          isDesktopSidebarOpen ? "px-4 justify-between" : "justify-center"
        )}>
          {isDesktopSidebarOpen && (
            <div className="flex items-center space-x-3">
              <img
                src="/logo.png"
                alt="Nommas AI"
                className="h-12 w-auto"
                style={{ objectFit: "contain", maxWidth: "200px" }}
              />
            </div>
          )}
          <button
            onClick={toggleDesktopSidebar}
            className="p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-all duration-200"
          >
            {isDesktopSidebarOpen ? (
              <ChevronLeft className="h-5 w-5" />
            ) : (
              <ChevronRight className="h-5 w-5" />
            )}
          </button>
        </div>
        <SidebarContent />
      </div>

      {/* Mobile Sidebar */}
      <div
        className={cn(
          "fixed inset-y-0 left-0 w-64 bg-[#171B21] transition-all duration-300 ease-in-out z-50 md:hidden",
          isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
        )}
      >
        <button
          onClick={() => setIsMobileSidebarOpen(false)}
          className="absolute right-4 top-5 text-gray-400 hover:text-white"
        >
          <X className="h-6 w-6" />
        </button>
        <div className="h-16 flex items-center px-4 border-b border-gray-800">
          <div className="flex items-center space-x-3">
            <img
              src="/logo.png"
              alt="Nommas AI"
              className="h-12 w-auto"
              style={{ objectFit: "contain", maxWidth: "200px" }}
            />
          </div>
        </div>
        <SidebarContent />
      </div>

      <div className={cn(
        "flex-1 flex flex-col min-h-screen md:min-h-0",
        isDesktopSidebarOpen ? "md:ml-64" : "md:ml-16"
      )}>
        <div className="h-16 flex-none bg-[#171B21] border-b border-gray-800 flex items-center px-4">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsMobileSidebarOpen(true)}
                className="text-gray-400 hover:text-white p-1.5 md:hidden"
              >
                <Menu className="h-5 w-5" />
              </button>
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent text-lg font-medium">
                {menuItems.find((item) => item.path === activePage)?.title || (activePage === "settings" ? "Settings" : "")}
              </span>
            </div>
            <button
              onClick={handleLogoutClick}
              className="md:hidden flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200"
            >
              <LogOut className="h-4 w-4" />
              <span>Sign out</span>
            </button>
          </div>
        </div>

        <div
          className="flex-1 overflow-y-auto scroll-smooth -mr-2 space-y-4"
          style={{
            scrollbarWidth: "thin",
            scrollbarColor: "#1f2937 transparent",
          }}
        >
          <div className="h-full">{children}</div>
        </div>
      </div>

      {isMobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setIsMobileSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default Layout;